import { EntitiesWithPossibleDisabledOptionsName } from '../../../types';
import { FormattingGroup, FormattingRule, TagFormatting } from '../types';
import { DEFAULT_FORMATTING_GROUP_LABEL } from '../../../consts';
import { APIEntityType } from '@ardoq/api-types';
import { getEmptyRuleByType } from '../utils';
import { type I18nLocale, t } from '@ardoq/i18n';

type GetDisabledOptionPopoverContent = (
  entityName: EntitiesWithPossibleDisabledOptionsName
) => string;

const getDisabledOptionProps = (
  entityName: EntitiesWithPossibleDisabledOptionsName,
  entitiesCount?: number,
  getDisabledOptionPopoverContent?: GetDisabledOptionPopoverContent
) => {
  if (entitiesCount || !getDisabledOptionPopoverContent) return undefined;

  return {
    isDisabled: true,
    popoverProps: {
      content: getDisabledOptionPopoverContent(entityName),
    },
  };
};

type AddFormattingRuleButtonOptionsArgs = {
  onFormattingRuleAdded: (rule: FormattingRule) => void;
  referencesFormattingGroups: FormattingGroup[];
  tagsFormattingGroups: TagFormatting[];
  getDisabledOptionPopoverContent?: GetDisabledOptionPopoverContent;
  isNewConditionalFormatting: boolean;
  i18nLocale: I18nLocale;
};

export const getAddFormattingRuleButtonOptions = ({
  onFormattingRuleAdded,
  referencesFormattingGroups,
  tagsFormattingGroups,
  getDisabledOptionPopoverContent,
  isNewConditionalFormatting,
  i18nLocale,
}: AddFormattingRuleButtonOptionsArgs) => {
  const referenceTypeCount = referencesFormattingGroups
    .find(group => group.label === DEFAULT_FORMATTING_GROUP_LABEL)
    ?.filters?.find(filter => filter.id === 'type')?.selectOptions?.length;

  return [
    {
      label: t(
        i18nLocale,
        'perspectives:addNewFormattingRuleButton.byComponent',
        'By Component'
      ),
      onClick: () =>
        onFormattingRuleAdded(
          getEmptyRuleByType(
            APIEntityType.COMPONENT,
            isNewConditionalFormatting
          )
        ),
    },
    {
      label: t(
        i18nLocale,
        'perspectives:addNewFormattingRuleButton.byReference',
        'By Reference'
      ),
      onClick: () =>
        onFormattingRuleAdded(
          getEmptyRuleByType(
            APIEntityType.REFERENCE,
            isNewConditionalFormatting
          )
        ),
      ...getDisabledOptionProps(
        'references',
        referenceTypeCount,
        getDisabledOptionPopoverContent
      ),
    },
    {
      label: t(
        i18nLocale,
        'perspectives:addNewFormattingRuleButton.byTag',
        'By Tag'
      ),
      onClick: () =>
        onFormattingRuleAdded(
          getEmptyRuleByType(APIEntityType.TAG, isNewConditionalFormatting)
        ),
      ...getDisabledOptionProps(
        'tags',
        tagsFormattingGroups.length,
        getDisabledOptionPopoverContent
      ),
    },
  ];
};
